import { useGetTasksQuery } from "./reportsApiSlice"
//import Task from "./Task"
import useAuth from "../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import UserTasks from "./UserTasks"
import getFilePath from "../../utils/getFilePath"
const ReportsList = ({users, tasks , responses, selectedTasks,  q}) => {


    const {groupId} = useParams()
    if(!users.length || !tasks.length  ) return <h1> אין נתונים להצגה</h1>
    if(!selectedTasks?.length ) return <h1> יש לבחור משימות</h1>
    let counter = 2
    tasks.map(task=>{
        if(selectedTasks.includes(task._id)){
            counter += task.actions.length
        }
    })
    let helper = 3
    const tableRow = (<>
     

    {users.map((user)=>{
        if(q==="" || user.username.includes(q) || user.name.includes(q)){
        return  <>
        <tr className="table__row">
            <td className="table__cell ">
                    {user.username}
                 
            </td>
            <td className="table__cell ">
            <span className="d-flex">
                    {user.name}
                    {user.image && <div className='profile-image' style={{backgroundImage:`url(${getFilePath(user.image)})`}}></div>}
                    </span>
               </td>
            <UserTasks key={user.username} username={user.username} selectedTasks={selectedTasks} tasks={tasks} responses = {responses} />
        </tr>
        </>
        }
       
    })}
   
        
    </>)

      const  content = (
            <>
            <table className={`table table--reports `} style={{gridTemplateColumns:`repeat(${counter},1fr)`}}>
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th task__title"> משתמש</th>
                        <th scope="col" className="table__th task__body">שם</th>
                        {tasks.map((task, taskindex)=>{
                            if(selectedTasks.includes(task._id)){
                            const prehelper = helper;
                            helper += task.actions?.length? task.actions.length:1
                            return <th key={taskindex} style={{gridColumn:`${prehelper}/${helper}`}} colSpan={task.actions.length} scope="col" className="table__th"> {task.title}</th>
                            }
                        })}
                    </tr>
                   
                </thead>
                <thead className="table__thead">
                <tr>
                        <th scope="col" className="table__th task__title"> </th>
                        <th scope="col" className="table__th task__body"></th>
                        {tasks.map(task=> { 
                            if(selectedTasks.includes(task._id)){
                             return task.actions.map(action=> <th key={action._id}  scope="col" className="table__th"> {action.title}</th>) 
                            }
                    })}
                    </tr>
                </thead>
                <tbody>
              {tableRow}
                </tbody>
            </table>
            </>
        )
  

    return content
}
export default ReportsList